<main class="chat-panel">
  <header class="chat-panel__header">
	<!-- Header reflects whichever chat Home has currently selected. -->
    <div class="chat-panel__identity">
      @if (contactUserId()) {
        <app-user-hover-card
          [name]="contactName()"
          [email]="contactEmail()"
          [avatarUrl]="contactAvatarUrl()"
          [initials]="getContactInitials()"
          [quickMessageUserId]="contactUserId()"
          [canQuickMessage]="!!contactUserId() && contactUserId() !== currentUserId()"
        >
          <div class="header-avatar" aria-hidden="true">
            <span class="header-avatar__media">
              @if (contactAvatarUrl()) {
                <img [src]="contactAvatarUrl()" [alt]="contactName() + ' profile photo'" />
              } @else {
                {{ getContactInitials() }}
              }
            </span>

    		@if (contactPresenceStatus()) {
    		  <span
    			class="chat-panel__presence-dot"
    			[class]="'chat-panel__presence-dot chat-panel__presence-dot--' + contactPresenceStatus()"
    			[attr.title]="getContactPresenceLabel()"
    			[attr.aria-label]="getContactPresenceLabel()"
    		  ></span>
    		}
          </div>
        </app-user-hover-card>
      } @else {
        <div class="header-avatar" aria-hidden="true">
          <span class="header-avatar__media">
            @if (contactAvatarUrl()) {
              <img [src]="contactAvatarUrl()" [alt]="contactName() + ' profile photo'" />
            } @else {
              {{ getContactInitials() }}
            }
          </span>

  		@if (contactPresenceStatus()) {
  		  <span
  			class="chat-panel__presence-dot"
  			[class]="'chat-panel__presence-dot chat-panel__presence-dot--' + contactPresenceStatus()"
  			[attr.title]="getContactPresenceLabel()"
  			[attr.aria-label]="getContactPresenceLabel()"
  		  ></span>
  		}
        </div>
      }
      <div>
        <h2>{{ contactName() }}</h2>
        <nav class="tab-nav" aria-label="Conversation tabs">
          <button class="tab-nav__item tab-nav__item--active" type="button">Chat</button>
        </nav>
      </div>
    </div>

    <div class="header-actions" aria-label="Call options">
      @if (getDisplayedActiveCallInfo(); as activeCall) {
        <button mat-flat-button color="primary" type="button" aria-label="Join call" (click)="onJoinActiveCall(activeCall.url)">
          <mat-icon aria-hidden="true">{{ activeCall.mode === 'audio' ? 'call' : 'videocam' }}</mat-icon>
          <span>Join Call</span>
        </button>
        @if (canEndActiveCall()) {
          <button mat-stroked-button color="warn" type="button" aria-label="End call" (click)="onEndCall()">
            <mat-icon aria-hidden="true">call_end</mat-icon>
            <span>End Call</span>
          </button>
        }
      } @else {
        <button class="icon-button" type="button" aria-label="Start audio call" [disabled]="isStartingCall()" (click)="onStartCall('audio')">
          <span class="material-icons">call</span>
        </button>
        <button class="icon-button" type="button" aria-label="Start video call" [disabled]="isStartingCall()" (click)="onStartCall('video')">
          <span class="material-icons">videocam</span>
        </button>
      }
      @if (hasChannelMenuActions()) {
        <button class="icon-button" type="button" aria-label="Conversation actions" [matMenuTriggerFor]="conversationMenu">
          <span class="material-icons">more_horiz</span>
        </button>

        <mat-menu #conversationMenu="matMenu" xPosition="before" panelClass="conversation-menu-panel">
          @if (canAddParticipants()) {
            <button mat-menu-item type="button" class="conversation-menu__item" (click)="onRenameGroup()">
              <mat-icon aria-hidden="true">edit</mat-icon>
              <span>Rename group</span>
            </button>
          }
          @if (canAddParticipants()) {
            <button mat-menu-item type="button" class="conversation-menu__item" (click)="onViewParticipants()">
              <mat-icon aria-hidden="true">group</mat-icon>
              <span>View members</span>
            </button>
          }
          @if (canAddParticipants()) {
            <button mat-menu-item type="button" class="conversation-menu__item" (click)="onAddParticipant()">
              <mat-icon aria-hidden="true">person_add</mat-icon>
              <span>Add user</span>
            </button>
          }
          @if (canLeaveChannel()) {
            <button mat-menu-item type="button" class="conversation-menu__item" (click)="onLeaveChannel()">
              <mat-icon aria-hidden="true">logout</mat-icon>
              <span>Leave channel</span>
            </button>
          }
        </mat-menu>
      }
    </div>
  </header>

  <!-- Scroll events here drive the mark-as-read callback back up to Home. -->
  <section #messageList class="message-list" aria-label="Conversation messages" (scroll)="onMessageListScroll()">
    @if (loadingOlderMessages()) {
      <p class="history-status">Loading older messages...</p>
    }

    @for (message of renderedMessages(); track (message.id || message.createdAt || message.time) + '-' + $index) {
	  <!-- Day separators are inserted only when the rendered date changes. -->
      @if (shouldShowDaySeparator($index, message.dayLabel)) {
        <p class="day-separator">{{ message.dayLabel }}</p>
      }

	  <!-- Unread divider is placed after the last message acknowledged by the active user. -->
      @if (shouldShowUnreadSeparator($index, message.id, message.own)) {
    <p class="unread-separator" data-unread-anchor="true">Unread messages</p>
      }

      @if (message.system) {
        <article class="message message--system" [class.message--highlighted]="isHighlightedMessage(message)" [attr.data-message-id]="message.id || null">
          <div class="message__system-badge">
            <p>{{ message.text }}</p>
          </div>
        </article>
      } @else {
        <article class="message" [class.message--own]="message.own" [class.message--highlighted]="isHighlightedMessage(message)" [attr.data-message-id]="message.id || null">
          <div class="message__body">
            <div class="message__meta">
              <strong>{{ message.sender | titlecase }}</strong>
              <time>{{ message.time }}</time>
              @if (message.edited && !message.deleted) {
                <span class="message__edited">edited</span>
              }
            </div>

            <div
              class="message__bubble-wrap"
              [class.message__bubble-wrap--with-actions]="hasHoverActions(message)"
              [class.message__bubble-wrap--with-reactions]="getMessageReactions(message).length > 0"
            >
              @if (hasHoverActions(message)) {
                <div
                  class="message__hover-actions"
                  [class.message__hover-actions--open]="isHoverActionsVisible(message)"
                  [class.message__hover-actions--bottom]="isHoverActionsBottom(message)"
                  aria-label="Message actions"
                  (mouseenter)="onHoverActionsEnter(message)"
                  (mouseleave)="onHoverActionsLeave(message)"
                >
                  @if (canReactToMessage(message)) {
                    @for (emoji of getDefaultReactionEmojis(); track emoji) {
                      <button class="message__reaction-quick-action" type="button" [attr.aria-label]="'React with ' + emoji" (click)="onToggleReaction(message, emoji)">
                        <span>{{ emoji }}</span>
                      </button>
                    }

                    <div class="message__hover-divider" aria-hidden="true"></div>
                    <div class="message__reaction-picker-shell" (click)="onReactionPickerClick($event)">
                      <button class="message__hover-action" type="button" aria-label="Add more reactions" (click)="toggleReactionPicker(message, $event)">
                        <mat-icon aria-hidden="true">sentiment_satisfied</mat-icon>
                      </button>

                      @if (isReactionPickerOpenForMessage(message) && !hasPersistedReactions(message)) {
                        <div
                          class="message__reaction-picker"
                          [class.message__reaction-picker--top]="isReactionPickerTop(message)"
                          [class.message__reaction-picker--left]="isReactionPickerLeft(message)"
                          role="dialog"
                          aria-label="Add reaction"
                        >
                          <emoji-picker preview-position="none" skin-tone-emoji="👍" (emoji-click)="onReactionEmojiPicked(message, $event)"></emoji-picker>
                        </div>
                      }
                    </div>
                  }

                  @if (canReactToMessage(message) && hasMessageActions(message)) {
                    <div class="message__hover-divider" aria-hidden="true"></div>
                  }

                  @if (canReplyMessage(message)) {
                    <button class="message__hover-action" type="button" aria-label="Reply to message" (click)="onReplyToMessage(message)">
                      <mat-icon aria-hidden="true">reply</mat-icon>
                    </button>
                  }
                  @if (canEditMessage(message)) {
                    <button class="message__hover-action" type="button" aria-label="Edit message" (click)="onEditMessage(message)">
                      <mat-icon aria-hidden="true">edit</mat-icon>
                    </button>
                  }
                  @if (canDeleteMessage(message)) {
                    <button class="message__hover-action" type="button" aria-label="Delete message" (click)="onDeleteMessage(message.id)">
                      <mat-icon aria-hidden="true">delete</mat-icon>
                    </button>
                  }
                </div>
              }

              <div
                #bubbleAnchor
                class="message__bubble"
                [class.message__bubble--deleted]="message.deleted"
                (mouseenter)="onMessageBubbleEnter(message, bubbleAnchor)"
                (mouseleave)="onMessageBubbleLeave(message)"
                (focusin)="onMessageBubbleEnter(message, bubbleAnchor)"
              >
              @if (getReplyPreview(message); as reply) {
                <button class="message__reply-quote" type="button" title="Jump to original message" (click)="scrollToReferencedMessage(reply.messageId)">
                  <strong>{{ reply.sender | titlecase }}</strong>
                  <span>{{ reply.attachmentName ? reply.text + ' • ' + reply.attachmentName : reply.text }}</span>
                </button>
              }
              @if (hasAttachment(message) && !message.deleted) {
                @if (getRenderedAttachmentMessages(message); as attachmentMessages) {
                @if (message.text.trim()) {
                  <p class="message__attachment-caption">
                    @for (segment of getMessageTextSegments(message); track $index) {
                      @if (segment.mention) {
                        <app-user-hover-card
                          [name]="getUserProfileName(segment.mentionedUserId, segment.mentionedUserName)"
                          [email]="getUserProfileEmail(segment.mentionedUserId)"
                          [avatarUrl]="getUserProfileAvatarUrl(segment.mentionedUserId)"
                          [initials]="getUserProfileInitials(segment.mentionedUserId, segment.mentionedUserName)"
                          [quickMessageUserId]="segment.mentionedUserId ?? null"
                          [canQuickMessage]="!!segment.mentionedUserId && segment.mentionedUserId !== currentUserId()"
                        >
                          <span
                            class="message__mention"
                            [class.message__mention--current-user]="segment.mentionedCurrentUser"
                          >{{ segment.text }}</span>
                        </app-user-hover-card>
                      } @else if (segment.taskReference) {
                        <button
                          class="message__task-reference"
                          type="button"
                          title="Open task details"
                          (click)="openTaskReference(segment.taskReferenceData)"
                        >{{ segment.text }}</button>
                      } @else {
                        <span>{{ segment.text }}</span>
                      }
                    }
                  </p>
                }
                <div class="message__attachment-list" [class.message__attachment-list--grouped]="attachmentMessages.length > 1">
                  @for (attachmentMessage of attachmentMessages; track attachmentMessage.id || $index) {
                    <div
                      class="message__attachment-entry"
                      [class.message__attachment-entry--grouped]="attachmentMessages.length > 1"
                      [class.message__attachment-entry--image]="isImageAttachment(attachmentMessage)"
                      [class.message__attachment-entry--file]="!isImageAttachment(attachmentMessage)"
                    >
                      @if (isImageAttachment(attachmentMessage)) {
                        <button
                          class="message__attachment-image"
                          [class.message__attachment-image--grouped]="attachmentMessages.length > 1"
                          type="button"
                          (click)="openImageViewer(attachmentMessage)"
                        >
                          <img [src]="attachmentMessage.attachmentUrl" [alt]="attachmentMessage.attachmentName || 'Image attachment'" (load)="onAttachmentImageLoad(attachmentMessage)" />
                        </button>
                      } @else {
                        <div class="message__attachment-file" [class.message__attachment-file--grouped]="attachmentMessages.length > 1">
                          <span class="material-icons" aria-hidden="true">{{ isPdfAttachment(attachmentMessage) ? 'picture_as_pdf' : 'description' }}</span>
                          <div class="message__attachment-copy">
                            <strong>{{ attachmentMessage.attachmentName }}</strong>
                            <span>{{ formatAttachmentSize(attachmentMessage) || (attachmentMessage.attachmentContentType || 'File') }}</span>
                          </div>
                        </div>
                      }

                      @if (!isImageAttachment(attachmentMessage)) {
                        <p class="message__attachment-title" [class.message__attachment-title--grouped]="attachmentMessages.length > 1">{{ attachmentMessage.attachmentName }}</p>
                      }
                      <div class="message__attachment-actions" [class.message__attachment-actions--grouped]="attachmentMessages.length > 1">
                        @if (!isImageAttachment(attachmentMessage)) {
                          <button type="button" (click)="openAttachment(attachmentMessage)">Open</button>
                        }
                        <button type="button" (click)="downloadAttachment(attachmentMessage)">Download</button>
                      </div>
                    </div>
                  }
                </div>
                }
              } @else {
                <p>
                  @for (segment of getMessageTextSegments(message); track $index) {
                    @if (segment.mention) {
                      <app-user-hover-card
                        [name]="getUserProfileName(segment.mentionedUserId, segment.mentionedUserName)"
                        [email]="getUserProfileEmail(segment.mentionedUserId)"
                        [avatarUrl]="getUserProfileAvatarUrl(segment.mentionedUserId)"
                        [initials]="getUserProfileInitials(segment.mentionedUserId, segment.mentionedUserName)"
                        [quickMessageUserId]="segment.mentionedUserId ?? null"
                        [canQuickMessage]="!!segment.mentionedUserId && segment.mentionedUserId !== currentUserId()"
                      >
                        <span
                          class="message__mention"
                          [class.message__mention--current-user]="segment.mentionedCurrentUser"
                        >{{ segment.text }}</span>
                      </app-user-hover-card>
                    } @else if (segment.taskReference) {
                      <button
                        class="message__task-reference"
                        type="button"
                        title="Open task details"
                        (click)="openTaskReference(segment.taskReferenceData)"
                      >{{ segment.text }}</button>
                    } @else {
                      <span>{{ segment.text }}</span>
                    }
                  }
                </p>
              }
              </div>

              @if (getMessageReactions(message).length) {
                <div class="message__reactions" aria-label="Message reactions">
                  @for (reaction of getMessageReactions(message); track reaction.emoji) {
                    <div
                      #reactionChipWrap
                      class="message__reaction-chip-wrap"
                      [class.message__reaction-chip-wrap--tooltip-open]="isReactionTooltipOpen(message, reaction)"
                      (mouseenter)="onReactionTooltipEnter(message, reaction, reactionChipWrap)"
                      (mouseleave)="onReactionTooltipLeave(message, reaction)"
                    >
                      <button
                        class="message__reaction-chip"
                        type="button"
                        [class.message__reaction-chip--active]="reaction.reactedByCurrentUser"
                        [attr.aria-label]="reaction.emoji + ' reaction, ' + reaction.count + ' response' + (reaction.count === 1 ? '' : 's')"
                        (click)="onToggleReaction(message, reaction.emoji)"
                      >
                        <span class="message__reaction-emoji">{{ reaction.emoji }}</span>
                        <span class="message__reaction-count">{{ reaction.count }}</span>
                      </button>

                      <div
                        class="message__reaction-tooltip"
                        [class.message__reaction-tooltip--bottom]="isReactionTooltipBottom(message, reaction)"
                        [class.message__reaction-tooltip--right]="isReactionTooltipRight(message, reaction)"
                        role="tooltip"
                        [attr.aria-label]="getReactionLabel(reaction.emoji)"
                      >
                        <p class="message__reaction-tooltip-title">{{ getReactionLabel(reaction.emoji) }}</p>

                        <div class="message__reaction-tooltip-list">
                          @for (participant of getReactionParticipants(reaction); track participant.id) {
                            <div class="message__reaction-tooltip-person">
                              <span class="message__reaction-tooltip-avatar" [style.--reaction-accent]="participant.accent">
                                {{ participant.initials }}
                              </span>
                              <span class="message__reaction-tooltip-name">{{ participant.name }}</span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  @if (canReactToMessage(message)) {
                    <div class="message__reaction-picker-shell message__reaction-picker-shell--inline" (click)="onReactionPickerClick($event)">
                      <button
                        class="message__reaction-chip message__reaction-chip--add"
                        type="button"
                        aria-label="Add reaction"
                        (click)="toggleReactionPicker(message, $event)"
                      >
                        <mat-icon aria-hidden="true">sentiment_satisfied</mat-icon>
                      </button>

                      @if (isReactionPickerOpenForMessage(message) && hasPersistedReactions(message)) {
                        <div
                          class="message__reaction-picker"
                          [class.message__reaction-picker--top]="isReactionPickerTop(message)"
                          [class.message__reaction-picker--left]="isReactionPickerLeft(message)"
                          role="dialog"
                          aria-label="Add reaction"
                        >
                          <emoji-picker preview-position="none" skin-tone-emoji="👍" (emoji-click)="onReactionEmojiPicked(message, $event)"></emoji-picker>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </article>
      }
    }
  </section>

  @if (imageViewerMessage(); as viewerMessage) {
    <div class="chat-image-viewer" role="dialog" aria-modal="true" aria-label="Image viewer" (click)="closeImageViewer()">
      <div class="chat-image-viewer__dialog" (click)="$event.stopPropagation()">
        <div class="chat-image-viewer__header">
          <div class="chat-image-viewer__meta">
            <strong>{{ viewerMessage.attachmentName || 'Image' }}</strong>
            <span>{{ viewerMessage.sender | titlecase }} • {{ viewerMessage.time }}</span>
          </div>
          <div class="chat-image-viewer__actions">
            <button type="button" class="chat-image-viewer__action" (click)="downloadAttachment(viewerMessage)">Download</button>
            <button type="button" class="chat-image-viewer__close" aria-label="Close image viewer" (click)="closeImageViewer()">
              <span class="material-icons" aria-hidden="true">close</span>
            </button>
          </div>
        </div>
        <div class="chat-image-viewer__body">
          <img [src]="viewerMessage.attachmentUrl" [alt]="viewerMessage.attachmentName || 'Image attachment'" />
        </div>
      </div>
    </div>
  }

  <!-- Composer emits raw text back to Home, which handles websocket send for the active channel. -->
  <footer
    class="composer"
    [class.composer--drag-active]="isComposerDragActive()"
    aria-label="Message composer"
    (dragenter)="onComposerDragEnter($event)"
    (dragover)="onComposerDragOver($event)"
    (dragleave)="onComposerDragLeave($event)"
    (drop)="onComposerDrop($event)"
  >
    @if (editingMessageId()) {
      <div class="composer__edit-banner" aria-label="Editing message">
        <div class="composer__edit-copy">
          <strong>Editing message</strong>
          <span>{{ editingMessagePreview() }}</span>
        </div>
        <button class="composer__edit-cancel" type="button" (click)="cancelEditing()">Cancel</button>
      </div>
    }
    @if (replyTarget(); as reply) {
      <div class="composer__reply-banner" aria-label="Replying to message">
        <div class="composer__reply-copy">
          <strong>Replying to {{ reply.sender | titlecase }}</strong>
          <span>{{ reply.attachmentName ? reply.text + ' • ' + reply.attachmentName : reply.text }}</span>
        </div>
        <button class="composer__edit-cancel" type="button" (click)="cancelReply()">Cancel</button>
      </div>
    }
    @if (pendingAttachments().length) {
      <div class="composer__attachment-preview-list" aria-label="Pending attachments">
        @for (attachment of pendingAttachments(); track attachment.id) {
          <div class="composer__attachment-preview">
            @if (hasPendingAttachmentPreview(attachment) && attachment.previewUrl; as previewUrl) {
              <img class="composer__attachment-preview-image" [src]="previewUrl" [alt]="attachment.file.name || 'Attachment preview'" />
            } @else {
              <div class="composer__attachment-preview-file" aria-hidden="true">
                <span class="material-icons">{{ attachment.file.type === 'application/pdf' ? 'picture_as_pdf' : 'description' }}</span>
              </div>
            }
            <div class="composer__attachment-preview-copy">
              <strong>{{ getPendingAttachmentName(attachment) }}</strong>
              <span>{{ getPendingAttachmentMeta(attachment) }}</span>
            </div>
            <button class="composer__attachment-preview-remove" type="button" (click)="removePendingAttachment(attachment.id)">Remove</button>
          </div>
        }
        <div class="composer__attachment-summary">{{ pendingAttachments().length }} attached • {{ getAttachmentSlotsLabel() }}</div>
      </div>
    }
    @if (isUploadingAttachment()) {
      <div class="composer__upload-status" aria-live="polite" aria-label="Uploading attachment">
        <span class="composer__upload-spinner" aria-hidden="true"></span>
        <span>Uploading {{ uploadingAttachmentLabel() || 'attachment' }}...</span>
      </div>
    }
    <div class="composer__row">
      <div class="composer__tools">
        <label class="icon-button composer__attachment-button" aria-label="Attach file">
          <span class="material-icons">{{ isUploadingAttachment() ? 'hourglass_top' : 'attach_file' }}</span>
          <input type="file" hidden multiple accept=".png,.jpg,.jpeg,.webp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt" [disabled]="isUploadingAttachment() || !canAddMoreAttachments()" (change)="onAttachmentInputChange($event)" />
        </label>
        <div class="composer__emoji" (click)="onEmojiPickerClick($event)">
          <button class="icon-button" type="button" aria-label="Insert emoji" [attr.aria-expanded]="isEmojiPickerOpen()" (click)="toggleEmojiPicker($event)">
            <span class="material-icons">sentiment_satisfied</span>
          </button>

          @if (isEmojiPickerOpen()) {
            <div class="composer__emoji-picker" role="dialog" aria-label="Emoji picker">
              <emoji-picker preview-position="none" skin-tone-emoji="👍" (emoji-click)="onEmojiPicked($event)"></emoji-picker>
            </div>
          }
        </div>
      </div>

      <label class="composer__input">
        <textarea
          #messageBox
          rows="1"
          placeholder="Type a new message"
          [disabled]="isUploadingAttachment()"
          (input)="onComposerInput(messageBox)"
          (blur)="onComposerBlur()"
          (paste)="onComposerPaste($event)"
          (keydown)="onComposerKeydown($event, messageBox)"
          (keydown.enter)="onComposerEnter($event, messageBox)"
        ></textarea>

        @if (hasMentionSuggestions()) {
          <div class="composer__mentions" role="listbox" aria-label="Mention suggestions" (mousedown)="$event.preventDefault()">
            @for (user of getFilteredMentionableUsers(); track user.userId; let index = $index) {
              <button
                class="composer__mention-option"
                type="button"
                role="option"
                [class.composer__mention-option--active]="isMentionSuggestionActive(index)"
                [attr.aria-selected]="isMentionSuggestionActive(index)"
                (click)="onMentionSuggestionSelected(user)"
              >
                <span class="composer__mention-name">{{ user.name }}</span>
                <span class="composer__mention-hint">&#64;{{ user.name.split(' ')[0] }}</span>
              </button>
            }
          </div>
        }

        @if (hasTaskSuggestions()) {
          <div class="composer__mentions" role="listbox" aria-label="Task suggestions" (mousedown)="$event.preventDefault()">
            @for (taskReference of getFilteredTaskReferences(); track taskReference.taskId; let index = $index) {
              <button
                class="composer__mention-option"
                type="button"
                role="option"
                [class.composer__mention-option--active]="isTaskSuggestionActive(index)"
                [attr.aria-selected]="isTaskSuggestionActive(index)"
                (click)="onTaskSuggestionSelected(taskReference)"
              >
                <span class="composer__mention-name">{{ taskReference.taskCode || taskReference.title }}</span>
                <span class="composer__mention-hint">{{ taskReference.taskCode ? taskReference.title : 'Task' }}</span>
              </button>
            }
          </div>
        }

		<button class="send-button" type="button" aria-label="Send message" [disabled]="isUploadingAttachment()" (click)="onSendMessage(messageBox)">
		  <span class="material-icons">{{ editingMessageId() ? 'check' : 'send' }}</span>
		</button>
      </label>

      <div class="composer__status" aria-live="polite" [attr.aria-hidden]="getTypingLabel() ? null : 'true'">{{ getTypingLabel() }}</div>
    </div>
  </footer>
</main>
